import Popup from "@/components/shared/Popup";
import { FiUsers, FiPlus, FiChevronRight } from "react-icons/fi";
import { type FamilyFicnOption } from "../useFAMIFormLogic";

export default function FAMIFicnPicker({
  options,
  onSelectFicn,
  onSelectNewFamily,
  onClose,
}: {
  options: FamilyFicnOption[];
  onSelectFicn: (ficn: string) => void;
  onSelectNewFamily: () => void;
  onClose: () => void;
}) {
  return (
    <Popup
      show={true}
      header={
        <div
          className="d-flex align-items-center gap-2"
          style={{ fontSize: "1.25rem" }}
        >
          <FiUsers size={20} />
          <span>Which family is this record for?</span>
        </div>
      }
      hasButton={false}
      secondButtonText="Cancel"
      size="lg"
      onClose={onClose}
      onSecondButtonClick={onClose}
    >
      <div className="ps-3 pe-3 pb-2">
        <p className="text-muted mb-3">
          Select a family to add a new record with a new effective date, or
          start a new family.
        </p>

        <div className="d-flex flex-column gap-2">
          {options.map((opt) => (
            <button
              key={opt.ficn}
              type="button"
              className="d-flex align-items-center justify-content-between text-start w-100 p-3 rounded bg-white"
              style={{
                cursor: "pointer",
                border: "1px solid #dee2e6",
                borderLeft: "5px solid #0d2b4e",
              }}
              onClick={() => onSelectFicn(opt.ficn)}
            >
              <span className="d-flex flex-column">
                <span className="fw-semibold">
                  {opt.headOfHousehold1 || "(No head of household)"}
                </span>
                <span className="text-muted" style={{ fontSize: "0.875rem" }}>
                  FICN {opt.ficn}
                  {opt.headOfHousehold2 ? ` · ${opt.headOfHousehold2}` : ""}
                  {opt.programYear ? ` · ${opt.programYear}` : ""}
                </span>
              </span>
              <FiChevronRight size={18} className="text-muted flex-shrink-0" />
            </button>
          ))}
        </div>

        <hr className="my-3" />

        <button
          type="button"
          className="text-start w-100 p-3 rounded bg-white"
          style={{
            cursor: "pointer",
            border: "1px solid #dee2e6",
            borderLeft: "5px solid #198754",
          }}
          onClick={onSelectNewFamily}
        >
          <span className="d-flex align-items-center gap-2 fw-semibold">
            <FiPlus size={18} className="flex-shrink-0" />
            New family
          </span>
          <span
            className="text-muted d-block mt-1"
            style={{ fontSize: "0.875rem" }}
          >
            Start a blank record with a new FICN
          </span>
        </button>
      </div>
    </Popup>
  );
}
